import React, { FC } from "react";
import { Dropdown } from "primereact/dropdown";
import { T } from "services/lang/LanguageService";
import { InputNumber } from "primereact/inputnumber";
import { DatasetDropdown } from "components/basic/dropdowns/dataset/DatasetDropdown";
import { DialIndicatorMinMaxValueEditorProps, ValueType } from "./DialIndicatorTypes";

const options = [
  { label: T("word.dataset"), value: ValueType.DATASET },
  { label: T("word.constant"), value: ValueType.CONSTANT },
];

const DialIndicatorMinMaxValueEditor: FC<DialIndicatorMinMaxValueEditorProps> = ({
  config,
  onConfigChange,
  isMinValue,
}) => {
  const getConstantValue = () => {
    if (isMinValue) {
      return (config.minValue as number) ?? 0;
    }
    return (config.maxValue as number) ?? 0;
  };

  return (
    <div className="w-full flex align-items-center gap-3 flex-wrap md:flex-nowrap">
      <div className="flex flex-column">
        <label htmlFor="usage">{isMinValue ? T("label.min-value") : T("label.max-value")}</label>
        <Dropdown
          id="usage"
          value={isMinValue ? config.minValueType : config.maxValueType}
          className="w-9rem p-inputtext-sm"
          options={options}
          onChange={e =>
            onConfigChange({ ...config, [isMinValue ? "minValueType" : "maxValueType"]: e.value })
          }
        />
      </div>
      {((isMinValue && config.minValueType === "constant") ||
        (!isMinValue && config.maxValueType === "constant")) && (
        <div className="flex flex-column">
          <label htmlFor="constant">{T("word.constant")}</label>
          <InputNumber
            id="constant"
            value={getConstantValue()}
            onValueChange={e =>
              onConfigChange({ ...config, [isMinValue ? "minValue" : "maxValue"]: e.value })
            }
            useGrouping={false}
            maxFractionDigits={2}
            className="p-inputtext-sm"
          />
        </div>
      )}
      {((isMinValue && config.minValueType === "dataset") ||
        (!isMinValue && config.maxValueType === "dataset")) && (
        <div className="w-full">
          <label htmlFor="baselineDataset">{T("label.baseline-dataset")}</label>
          <DatasetDropdown
            value={String(isMinValue ? config.minValue : config.maxValue)}
            onChange={val =>
              onConfigChange({ ...config, [isMinValue ? "minValue" : "maxValue"]: val })
            }
          />
        </div>
      )}
    </div>
  );
};

export default DialIndicatorMinMaxValueEditor;
